import { render, staticRenderFns } from "./ProductAddOn.vue?vue&type=template&id=6aead8dc&scoped=true&"
import script from "./ProductAddOn.vue?vue&type=script&lang=js&"
export * from "./ProductAddOn.vue?vue&type=script&lang=js&"
import style0 from "./ProductAddOn.vue?vue&type=style&index=0&id=6aead8dc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aead8dc",
  null
  
)

export default component.exports